import React, { ReactNode, useEffect, useState } from 'react'
import { Blockchain } from '../pages/private/ManageDraft/types'


const BlockchainCtx = React.createContext(null)

export const useBlockchain = () => {
    return React.useContext(BlockchainCtx)
}
const blch = sessionStorage.getItem("blch") || Blockchain.Solana
function BlockchainContext({ children }: { children: ReactNode }) {
    const [currentBlockchain, setCurrent] = useState<string>(Blockchain.Solana)

    useEffect(() => {
        console.log(blch);
        
        setCurrent(blch)
    }, [])

    

    const setCurrentBlockchain = (val: string) => {
        sessionStorage.setItem("blch", val)
        setCurrent(val)
    }
    const value: any = {
        currentBlockchain,
        setCurrentBlockchain
    }
    return (
        <BlockchainCtx.Provider value={value}>
            {children}
        </BlockchainCtx.Provider>
    )
}

export default BlockchainContext